import PropTypes from 'prop-types';
import React from 'react';
import FlexBox from 'flexbox-react';
import RouterLink from 'components/RouterLink';
import { ThemeProvider } from 'react-css-themr';
import Card from 'components/Card';
import DetailsAddress from 'components/DetailsAddress';
import { ResourceDetailsCardElement } from 'components/ResourceCardElements';
import UserCard from 'components/users/UserCard';
import theme from 'styles/resourceDetailsCard.scss';
import sectionTheme from 'styles/detailsSection.scss';
import detailsCardElement from 'styles/detailsCardElement.scss';
import WorkroomType from 'types/workroom';

const detailsTheme = { RTCard: theme, ResourceDetailsCE: detailsCardElement };

const filterUsersByRole = (user, role) => {
  if (role === 'estimator') {
    return [
      'Estimation Coordinator',
      'Installation Service Manager',
      'Quality Assurance Specialist',
    ].includes(user.position);
  }
  if (role === 'installer') {
    return [
      'Installation Coordinator',
      'Installation Service Manager',
      'Quality Assurance Specialist',
      'Area Installation Specialist',
    ].includes(user.position);
  }
  return true;
};

const WorkroomDetailsCard = (props) => {
  const { workroom, canEdit, users, role } = props;
  const { vendor } = workroom;
  const statusText = workroom.active ? 'Active' : 'Inactive';
  const EditAction = (<RouterLink className={theme.detailsLink} to={`/workrooms/${workroom.id}/edit`}>
    <span className={theme.editText}>{vendor === 'IFI' ? 'Edit District' : 'Edit Workroom'}</span>
  </RouterLink>);
  const sortedUsers = users.sort((a, b) => {
    if (a.employable_type < b.employable_type) return -1;
    if (a.employable_type > b.employable_type) return 1;
    return 0;
  })
  .filter(user => filterUsersByRole(user, role))
  .map(user => ({ ...user, id: user.employable_id }));
  return (<ThemeProvider theme={detailsTheme}>
    <div>
      <Card>
        <section className={sectionTheme.section}>
          <FlexBox justifyContent="space-between">
            <div>
              <div className={theme.mainTitle}>
                <span className={theme.boldWord}>{workroom.name} </span>
                <span className={workroom.active ? theme.activeText : theme.inactiveText}>
                  ({statusText})
                </span>
              </div>
              <DetailsAddress
                className={theme.mainSubtitle}
                address={workroom.address}
                city={workroom.city}
                state={workroom.state}
                zipCode={workroom.zip_code}
              />
            </div>
            {canEdit ? EditAction : null}
          </FlexBox>
        </section>
        <hr className={theme.dividerLine} />
        <section className={sectionTheme.section}>
          <FlexBox flexWrap="wrap" className={theme.detailsElementContainer}>
            <ResourceDetailsCardElement title="vendor" value={workroom.vendor} />
            <ResourceDetailsCardElement title="phone number">
              {workroom.phone_number}
            </ResourceDetailsCardElement>
            <ResourceDetailsCardElement title="accounting id" value={workroom.accounting_id} />
            <ResourceDetailsCardElement title="inventory id" value={workroom.inventory_id} />
          </FlexBox>
        </section>
      </Card>
      <div>
        {sortedUsers.map(user => <UserCard
          key={`${user.id}-${user.employable_type}`}
          user={user}
          type={`${user.employable_type}s`}
          showEmployableType
          clickable={role !== 'estimator' && role !== 'installer'}
        />)}
      </div>
    </div>
  </ThemeProvider>);
};

WorkroomDetailsCard.defaultProps = { users: [] };

WorkroomDetailsCard.propTypes = {
  workroom: WorkroomType.isRequired,
  canEdit: PropTypes.bool,
  users: PropTypes.array,
  role: PropTypes.string,
};

export default WorkroomDetailsCard;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/workrooms/components/workroomDetailsCard.jsx